import headerBg from '@/assets/images/active/travel/header/header_bg.png';
import headerBg2 from '@/assets/images/active/travel/header/header_bg2.png';
import officeBtn from '@/assets/images/active/travel/header/btn_05.png';
import loginBtn from '@/assets/images/active/travel/header/btn_06.png';
import accountBtn from '@/assets/images/active/travel/header/btn_07.png';
import activeBtn from '@/assets/images/active/travel/header/btn_09.png';
import logoutBtn from '@/assets/images/active/travel/header/btn_10.png';

export const headerConfig = {
  not_logged_in: {
    background_image: headerBg,
    style: ''
  },
  logged_in: {
    background_image: headerBg2,
    main_title_color: '#825339',
    sub_title_color: '#825339',
    tips_color: '#825339',
    game_name: '时光旅行社'
  },
  operation_btn: {
    office_website: {
      width: '',
      height: '',
      background_image: '',
      img: officeBtn,
      style: 'top: 0.35rem; display: none',
      link: 'https://sglxs.qingcitimes.com/'
    },
    login: {
      width: '',
      height: '',
      background_image: '',
      img: loginBtn,
      style: 'top: 0.35rem'
    },
    change_account: {
      width: '',
      height: '',
      background_image: '',
      img: accountBtn,
      style: 'top: 0.35rem'
    },
    join_active: {
      width: '',
      height: '',
      background_image: '',
      img: activeBtn,
      style: 'top: 0.35rem',
      link: 'https://qcg.ink/XrLOO4'
    },
    logout: {
      width: '',
      height: '',
      img: logoutBtn,
      style: 'top: 0.35rem'
    }
  }
};



// WEBPACK FOOTER //
// ./src/pages/travel/superPunchClock/headerConfig.js.js